import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'components/v2/drop-down/drop-down';
import DivButton from 'components/v2/div-button/div-button';

import css from './table-action-column.less';

class TableActionColumn extends Component {
  constructor(props) {
    super(props);
    this.lastTimeout = {};
  }

  /* implement the same function like this if wanna hide dropdown when user select dropdown item */
  // hideActionDropdown = () => {
  //   const { id } = this.props;
  //   try {
  //     const actionDropdown = document.getElementById(id);
  //     actionDropdown.click();
  //   } catch (e) {
  //     // do nothing
  //   }
  // };

  render() {
    const { id, items, buttonClick, placement } = this.props;
    return (
      <Dropdown
        items={items}
        className={css.ongoingOrderTableActionDropdown}
        placement={placement}
      >
        {/* eslint-disable */}
        <DivButton id={id} className={css.threedotIcon} onClick={buttonClick}>
          <img src={require('public/images/three-dots-v2.svg')} alt="" />
        </DivButton>
        {/* eslint-enable */}
      </Dropdown>
    );
  }
}

TableActionColumn.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      icon: PropTypes.node,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  buttonClick: PropTypes.func,
  placement: PropTypes.string,
};

TableActionColumn.defaultProps = {
  buttonClick: undefined,
  placement: 'bottomLeft',
};

export default TableActionColumn;
